import { useNavigate } from "@tanstack/react-router";

import ActionButton from "@/components/Button/ActionButton";
import { Card } from "@/components/Card/card";
import { HStack } from "@/components/Layout";
import { defaultNS, useTranslation } from "@/lib/i18n";

type Props = {
  baseLink: string;
  previousPage: string | null;
  nextPage: string | null;
  onNextClick: () => void;
  nextComplete?: boolean;
  onCompleteClick?: () => void;
  disabled: boolean;
};

const DockAddStepperAction = ({
  baseLink,
  previousPage,
  nextPage,
  nextComplete,
  disabled,
  onNextClick,
  onCompleteClick,
}: Props) => {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "common.action",
  });

  const navigate = useNavigate();

  return (
    <HStack className="w-full px-6 mt-auto">
      <Card className="flex w-full items-center p-2">
        {previousPage && (
          <ActionButton
            className="gap-2"
            size="sm"
            variant="ghost"
            icon="ChevronLeft"
            iconColor="active"
            onClick={() => {
              navigate({ to: baseLink, hash: previousPage, search: true });
            }}
          />
        )}

        {nextPage && !nextComplete && (
          <ActionButton
            className="ml-auto items-center gap-2"
            size="sm"
            variant="default"
            disabled={disabled}
            icon="ChevronRight"
            iconPosition="right"
            onClick={onNextClick}
          >
            {t("next")}
          </ActionButton>
        )}

        {!nextPage && nextComplete && (
          <ActionButton
            className="ml-auto items-center gap-2"
            size="sm"
            variant="default"
            disabled={disabled}
            icon="ChevronRight"
            iconPosition="right"
            onClick={onCompleteClick}
          >
            {t("complete")}
          </ActionButton>
        )}
      </Card>
    </HStack>
  );
};

export default DockAddStepperAction;
